'next/client'

import React, { memo } from 'react';
import ImageComponent from '@/components/UiElements/ImageComponent';
import { FlattedCategory } from '@/types/category';

interface CategoryButtonProps {
    category: FlattedCategory;
    onClick?: (category: FlattedCategory) => void;
}

const CategoryButton: React.FC<CategoryButtonProps> = ({
   category,
   onClick,
}) => {


    const classNames = {
        wrapper: 'relative block h-[150px] ',
        button:
            'group !bg-transparent overflow-visible !p-[0px] !border-none !m-[6px] relative !h-[100%] w-[100%] ' +
            `${category.isActive ? 'cursor-pointer' : 'opacity-30'} ` +
            "before:block before:content-[''] before:w-[100%] before:h-[100%] before:absolute before:top-0 before:left-0 before:bg-white before:border before:border-gray-300 before:-rotate-6 before:rounded-md before:z-[1] " +
            "after:block after:content-[''] after:w-[100%] after:h-[100%] after:absolute after:top-0 after:left-0 after:bg-white after:border after:border-gray-300 after:rotate-3 after:rounded-md after:z-[1]",
        content:
            'relative flex flex-col w-full h-full border border-gray-300 rounded-md justify-between items-center bg-white group-hover:border-gray-500 transition-all p-[5px] z-[2]',
        badge:
            'absolute top-[5px] right-[5px] flex flex-row gap-xs',
        count:
            'px-sm rounded-sm  text-sm flex flex-row gap-sm justify-center items-center ' +
            `${category.childCount ? 'bg-primary-100 text-primary-800' : 'bg-red-100 text-red-800'}`,
        home: 'text-xs text-primary-800 px-xs rounded-sm  text-sm bg-primary-500 font-icon-solid !text-white flex items-center justify-center',

        label: 'w-full text-sm text-center',
    };

    const handleClick = async () => {
        onClick?.(category);
    };

    return (
        <div className={classNames.wrapper}>
            <div className={classNames.button} onClick={handleClick}>

                <div className={classNames.content}>
                    <div className="flex-1 flex justify-center items-center w-full relative">
                        <ImageComponent src={category.img} className="!max-h-[80px]" />
                    </div>
                    <div className={classNames.badge}>

                        <div className={classNames.count}>
                            <span className={"font-icon-solid text-xs opacity-[0.5]"}></span>{category.childCount ? category.childCount : "Empty" }
                        </div>
                        {(category.childCategory && category.childCategory > 0) &&
                            <span className={classNames.count}>
                                <span className={"font-icon-solid text-xs opacity-[0.5]"}></span>{category.childCategory}
                            </span>
                        }
                        {category.showOnHome &&
                            <span className={classNames.home}></span>
                        }

                    </div>
                    <span className={classNames.label}>{category.name}</span>
                </div>
            </div>
        </div>
    );
};

export default memo(CategoryButton);
